import {
  Box,
  Button,
  Badge,
  Flex,
  Heading,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  ModalHeader,
  Text,
  useToast,
  Divider,
  Spinner,
  Tooltip,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  PopoverFooter,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  // Image, Avatar,   Card, CardBody, TableContainer, Table, Thead, Tr, Th, Tbody, Td
} from "@chakra-ui/react";

import { AiOutlineDown } from "react-icons/ai";
import { BiArrowBack } from "react-icons/bi";
import React, { Fragment, useEffect, useState, useContext } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import OtpDeliveryBoy from "./OtpDeliveryBoy";
import GenerateInvoice from "./GenerateInvoice";
import { useReactToPrint } from "react-to-print";
import { Auth } from "./Auth";
import OrderInvoice from "./OrderInvoice";
import { useRef } from "react";
import { Context } from "./store";
import UpdateDeliveryDateButton from "./UpdateDeliveryDateButton";
import ConfirmModal from "./ConfirmModal";
const DetailsHeader = ({
  title,
  mobile,
  deliveredRender,
  variant,
  colorScheme,
  invoice,
  menuItems,
  changeStatusId,
  handleChildStateChange,
  orderName,
  invoiceDetails,
  updateTenureDetailsTable,
  orderData,
  tenureData,
  tenureStatus,
}) => {
  const [otpModalToggle, setOtpModalToggle] = useState(false);
  const [render, setRender] = useState(0);
  const [prevSelectedPartner, setPrevSelectedPartner] = useState([]);
  const [invoiceToggle, setInvoiceToggle] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [allUser, setAllUser] = useState([]);
  const [isInvoiceGen, setIsInvoiveGen] = useState(false);
  const [getInvoice, setGetInvoice] = useState([]);
  const [changeStatusDisable, setChangeStatusDisable] = useState(false);

  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [openArchiveConfirm, setOpenArchiveConfirm] = useState(false);
  const onClose1 = () => setIsOpen1(false);
  const onClose3 = () => setIsOpen3(false);
  const onOpen1 = () => setIsOpen1(true);
  const onOpen3 = () => setIsOpen3(true);
  const onClose2 = () => setIsOpen2(false);
  const onOpen2 = () => setIsOpen2(true);

  const { id } = useParams();
  const toast = useToast();
  const navigate = useNavigate();
  const orderInvoiceRef = useRef(null);

  let convertedDateStr = 0;
  if (title === "Order") {
    const originalDateStr =
      tenureData.length > 0 ? tenureData[tenureData.length - 1].endDate : null;
    const originalDate = new Date(originalDateStr);

    // Step 2: Set the month, day, and time to match "2023-05-16"
    originalDate.setMonth(4); // Months are zero-based, so 4 is May (January is 0)
    originalDate.setDate(16);
    originalDate.setHours(0, 0, 0, 0); // Reset the time to midnight

    // Step 3: Convert the modified date back to a string in the desired format "yyyy-MM-dd"
    convertedDateStr = originalDate.toISOString().slice(0, 10);
  }

  // const user = JSON.parse(localStorage.getItem("user"))
  // const userPermission = user.UserGroupPermission
  const { userData } = useContext(Context);
  const user = userData;
  const userPermission = user.UserGroupPermission;

  const calObj = JSON.parse(sessionStorage.getItem("invoiceTotalCal"));

  const menuStyle = {
    fontSize: "12",
    fontWeight: "400",
    letterSpacing: "0.1",
    transition: "all 0.25s",
    _first: {
      bgColor: "transparent",
    },
    _hover: {
      bgColor: "rgba(67, 138, 254, 0.1)",
    },
  };
  const menuButton = {
    // px: '8',
    // py: '19',
    h: "34px",
    // w: '203px',
    bgColor: "#FFFFFF",
    _hover: { bgColor: "rgba(67, 138, 254, 0.1)" },
    color: "#438AFE",
    borderRadius: "45px",
  };

  // Status Handler
  const statusHandler = (element) => {
    
    // Delivery boy Otp Modal toggle
    // if((title === 'Order ID') && (element.status === "ORDER_DELIVERED")){
    //   setOtpModalToggle(true)
    //   onOpen2()
    // }

    // OTP
    if (
      user.UserGroupPermission.includes("DELIVERY_MANAGEMENT") &&
      (user.userGroupMember.includes("DELEVERY_BOY") ||
        user.userGroupMember.includes("MEMBER")) &&
      element.status === "ORDER_DELIVERED"
    ) {
      setOtpModalToggle(true);
      onOpen2();
    }
    
    if (element.status === "EARLY_CLOSURE") {
      setOpenEarlyClosureConfirm(true);
      return;
    }
    // ORDER PUBLISH STATUS CHANGE
    if (element.status === "ORDER_PUBLISHED") {
      setChangeStatusDisable(true);
      let data = JSON.stringify({
        orderId: `${id}`,
        isAutoVerified: false,
        orderGstNumber:
          orderData.orderGstNumber !== null
            ? orderData.orderGstNumber
            : "n/a: Gst was not provided while creating order",
        reqType: "POST",
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/shopify/sync-draft-order`,
        headers: {
          "Content-Type": "application/json",
          Authorization: Auth(),
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          setChangeStatusDisable(false);
          toast({
            title: `${element.title}`,
            status: "success",
            duration: 4000,
            isClosable: true,
            position: "top",
          });
          handleChildStateChange(element.status);
        })
        .catch((error) => {
          console.log(error);
          setChangeStatusDisable(false);
          toast({
            title: `Oops we are facing some temporary issue with your request!`,
            position: "top",
            status: "error",
            duration: 4000,
            isClosable: true,
          });
        });
    }

    // CHANGE STATUS & UPDATE TICKET +++ OUT_FOR_DELIVERY

    if (title === "Order" && element.status === "ORDER_OUT_FOR_DELIVERY") {
      setChangeStatusDisable(true);

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        // url: `${process.env.REACT_APP_RALCO_API_URL}/api/msg91/send-otp?mobile=918051542244`,
        url: `${
          process.env.REACT_APP_RALCO_API_URL
        }/api/msg91/send-otp?mobile=${Number(mobile.split("+")[1])}`,
        headers: {
          Authorization: Auth(),
        },
      };

      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data), '#################');
          let otp = response.data.otp;
          // ==== STATUS CHANGE & Ticket Updatation
          let data = JSON.stringify({
            orderStatusId: `${element.status}`,
          });

          let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
            headers: {
              "Content-Type": "application/json",
              Authorization: Auth(),
            },
            data: data,
          };

          axios
            .request(config)
            .then((response) => {
              // console.log(JSON.stringify(response.data));
              setChangeStatusDisable(false);

              toast({
                title: `${element.title}`,
                status: "success",
                duration: 4000,
                isClosable: true,
                position: "top",
              });
              handleChildStateChange(element.status);

              // ################# AFTER ORDER TICKET CREATION ###########################
              // GET TICKET
              // let getTicket = {
              //   method: "get",
              //   maxBodyLength: Infinity,
              //   url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/get-ticket-with-order-id/${id}`,
              //   headers: {
              //     "Content-Type": "application/json",
              //     Authorization: Auth(),
              //   },
              // };

              // axios
              //   .request(getTicket)
              //   .then((response) => {
              //     // console.log(JSON.stringify(response.data));
              //     const data = response.data;
              //     let ticketObj = data.filter(
              //       (x) =>
              //         x.shopifyOrderId === id &&
              //         x.ticketObj.custom_fields.cf_ticket_type ===
              //           "CUSTOMER_VERIFICATION_TICKET" &&
              //         x.ticketObj.custom_fields.cf_status ===
              //           "VERIFIED_SUCCESSFULLY"
              //     );
              //     let ticketId = ticketObj[0]?.ticketId;

              //     let myPayload = JSON.stringify({
              //       freshdesk: {
              //         custom_fields: {
              //           cf_otp: `${otp}`,
              //           cf_ticket_type: "ORDER_TICKET",
              //           cf_status: "ORDER_PICKED_UP",
              //         },
              //       },
              //     });
              //     // Update Ticket
              //     let config = {
              //       method: "put",
              //       maxBodyLength: Infinity,
              //       url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/update-ticket/${ticketId}`,
              //       headers: {
              //         "Content-Type": "application/json",
              //         Authorization: Auth(),
              //       },
              //       data: myPayload,
              //     };

              //     axios
              //       .request(config)
              //       .then((response) => {
              //         // console.log(JSON.stringify(response.data));
              //         console.log(
              //           "Ticket Updated Successfullyyy --- ORDER #####################################"
              //         );
              //       })
              //       .catch((error) => {
              //         console.log(error);
              //       });
              //   })
              //   .catch((error) => {
              //     console.log(error);
              //   });

              // ========= ticket req end=========
            })
            .catch((error) => {
              console.log(error);
              setChangeStatusDisable(false);

              toast({
                title: `Something went wrong please try again`,
                status: "error",
                duration: 4000,
                isClosable: true,
                position: "top",
              });
            });
        })
        .catch((error) => {
          console.log(error);
          toast({
            title: `Something went wrong please try again`,
            status: "error",
            duration: 4000,
            isClosable: true,
            position: "top",
          });
        });
    }

    // go to order verification page
    if (element.status === "ORDER_VERIFIED") {
      navigate(`/verification/customer-verification-details/${id}`);
    }

    // ========== Change Order Status & UPDATE TICKET  A-P-I ===========

    const isUserAdmin = user.userGroupMember.includes("ADMIN");
    const isUserMember = user.userGroupMember.includes("MEMBER");
    const isUserDeliveryBoy = user.userGroupMember.includes("DELEVERY_BOY");

    const isOrderCancelled = element.status === "ORDER_CANCELED";
    const isOrderNotVerified = element.status !== "ORDER_VERIFIED";
    const isOrderNotOutForDelivery =
      element.status !== "ORDER_OUT_FOR_DELIVERY";
    const isOrderNotPublished = element.status !== "ORDER_PUBLISHED";

    const hasOrderManagementPermission =
      userPermission.includes("ORDER_MANAGEMENT");

    const isOrderNotVerifiedOrOutForDeliveryOrNotPublished =
      isOrderNotVerified && isOrderNotOutForDelivery && isOrderNotPublished;
    const isUserAdminOrHasOrderManagementPermissionOrMemberOrDeliveryBoyAndOrderCancelled =
      isUserAdmin ||
      hasOrderManagementPermission ||
      ((isUserDeliveryBoy || isUserMember) && isOrderCancelled);
    const isUserAdminOrMemberOrDeliveryBoyAndOrderCancelled =
      isUserAdmin || isUserMember || (isUserDeliveryBoy && isOrderCancelled);

    if (element.status == "COMPLETED") {
      setOpenConfirmModal(true);
      return;
    }

    if (
      isOrderNotVerifiedOrOutForDeliveryOrNotPublished &&
      (isUserAdminOrHasOrderManagementPermissionOrMemberOrDeliveryBoyAndOrderCancelled ||
        isUserAdminOrMemberOrDeliveryBoyAndOrderCancelled)
    ) {
      setChangeStatusDisable(true);
      let data = JSON.stringify({
        orderStatusId: `${element.status}`,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: Auth(),
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          setChangeStatusDisable(false);
          toast({
            title: `${element.title}`,
            status: "success",
            duration: 4000,
            isClosable: true,
            position: "top",
          });
          handleChildStateChange(element.status);

          // ################# AFTER ORDER TICKET CREATION ###########################
          // GET TICKET
          // let getTicket = {
          //   method: "get",
          //   maxBodyLength: Infinity,
          //   url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/get-ticket-with-order-id/${id}`,
          //   headers: {
          //     "Content-Type": "application/json",
          //     Authorization: Auth(),
          //   },
          // };

          // axios
          //   .request(getTicket)
          //   .then((response) => {
          //     // console.log(JSON.stringify(response.data));
          //     const data = response.data;
          //     let ticketObj = data.filter(
          //       (x) =>
          //         x.shopifyOrderId === id &&
          //         x.ticketObj.custom_fields.cf_ticket_type ===
          //           (element.status === "ORDER_OUT_FOR_DELIVERY"
          //             ? "CUSTOMER_VERIFICATION_TICKET"
          //             : element.status === "ORDER_DELIVERED"
          //             ? "ORDER_TICKET"
          //             : null) &&
          //         x.ticketObj.custom_fields.cf_status ===
          //           (element.status === "ORDER_OUT_FOR_DELIVERY"
          //             ? "VERIFIED_SUCCESSFULLY"
          //             : element.status === "ORDER_DELIVERED"
          //             ? "ORDER_PICKED_UP"
          //             : null)
          //     );
          //     let ticketId = ticketObj[0]?.ticketId;

          //     let myPayload = JSON.stringify({
          //       freshdesk: {
          //         custom_fields: {
          //           cf_ticket_type: "ORDER_TICKET",
          //           cf_cutoff_date: `${convertedDateStr.toString()}`, // cut-off date mein end date h (tenure end date)
          //           cf_status:
          //             element.status === "ORDER_DELIVERED"
          //               ? "ORDER_DELIVERED"
          //               : element.status === "ORDER_OUT_FOR_DELIVERY"
          //               ? "ORDER_PICKED_UP"
          //               : null,
          //         },
          //       },
          //     });
          //     // Update Ticket
          //     let config = {
          //       method: "put",
          //       maxBodyLength: Infinity,
          //       url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/update-ticket/${ticketId}`,
          //       headers: {
          //         "Content-Type": "application/json",
          //         Authorization: Auth(),
          //       },
          //       data: myPayload,
          //     };

          //     axios
          //       .request(config)
          //       .then((response) => {
          //         // console.log(JSON.stringify(response.data));
          //         console.log(
          //           "Ticket Updated Successfullyyy --- ORDER #####################################"
          //         );
          //       })
          //       .catch((error) => {
          //         console.log(error);
          //       });
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });

          // ==================
        })
        .catch((error) => {
          setChangeStatusDisable(false);
          console.log(error);
          toast({
            title: `Something went wrong please try again`,
            status: "error",
            duration: 4000,
            isClosable: true,
            position: "top",
          });
        });
    }
  };

  const markOrderComplete = () => {
    setChangeStatusDisable(true);
    let data = JSON.stringify({
      orderStatusId: "COMPLETED",
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        setChangeStatusDisable(false);
        toast({
          title: "Completed",
          status: "success",
          duration: 4000,
          isClosable: true,
          position: "top",
        });
        handleChildStateChange("COMPLETED");
      })
      .catch((error) => {
        setChangeStatusDisable(false);
        console.log(error);
        toast({
          title: error.response.data.message,
          status: "error",
          duration: 4000,
          isClosable: true,
          position: "top",
        });
      });

    setOpenConfirmModal(false);
  };

  const markOrderEarlyClosure = () => {
    setChangeStatusDisable(true);
    let data = JSON.stringify({
      orderStatusId: "EARLY_CLOSURE",
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        setChangeStatusDisable(false);
        toast({
          title: "EARLY_CLOSURE",
          status: "success",
          duration: 4000,
          isClosable: true,
          position: "top",
        });
        handleChildStateChange("EARLY_CLOSURE");
      })
      .catch((error) => {
        setChangeStatusDisable(false);
        console.log(error);
        toast({
          title: error.response.data.message,
          status: "error",
          duration: 4000,
          isClosable: true,
          position: "top",
        });
      });

    setOpenEarlyClosureConfirm(false);
  };

  // #### Get Delivery Boy ######
  const deliveryBoyList = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/all-accounts`,
      headers: {
        Authorization: Auth(),
      },
    };

    axios
      .request(config)
      .then((response) => {
        setAllUser(response.data.users);
      })
      .catch((error) => {
        console.log(error);
        // setAllUser(error.response.data.users);
      });
  };

  let pickedPartner = allUser?.filter(
    (x) => x?.partyId === prevSelectedPartner[0]?.partyId
  );
  // ##### Assign Delivery #####
  const assignDelivery = (e) => {
    let data = JSON.stringify({
      partyId: `${e.partyId}`,
      orderId: `${orderData.id}`,
      orderItemSeqId: orderData.OrderItem[0].orderItemSeqId,
      roleTypeId: "DELIVERY_PARTNER",
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/party/member`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        toast({
          title: `Order assigned for delivery`,
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        setRender((prev) => prev + 1);
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: `Something went wrong please try again`,
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      });
  };

  // ###### To check delivery boy assign or not ##########
  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/party/member?orderId=${orderData?.id}&orderItemSeqId=${orderData?.OrderItem[0]?.orderItemSeqId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
    };
    if (title !== "Tenure") {
      axios
        .request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          setPrevSelectedPartner(response.data);
          deliveryBoyList();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [orderData, render, toast, title]);

  // ######## Remove assigned delivery boy #####
  const removeAssignedPartner = () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/party/member?orderId=${prevSelectedPartner[0]?.orderId}&partyId=${prevSelectedPartner[0]?.partyId}&roleTypeId=${prevSelectedPartner[0]?.roleTypeId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setRender((prev) => prev + 1);
        toast({
          title: `Assigned delivery partner removed`,
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: `Something went wrong please try again`,
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      });
  };

  // //  #### P R I N T ORDER INVOICE LOGIC ######
  // // We store the resolve Promise being used in `onBeforeGetContent` here
  const promiseResolveRef = useRef(null);

  // We watch for the state to change here, and for the Promise resolve to be available
  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
      promiseResolveRef.current();
    }
  }, [isPrinting]);

  const handlePrint = useReactToPrint({
    content: () => orderInvoiceRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        promiseResolveRef.current = resolve;
        setIsPrinting(true);
        setInvoiceToggle(true);
      });
    },
    onAfterPrint: () => {
      // Reset the Promise resolve so we can print again
      promiseResolveRef.current = null;
      setIsPrinting(false);
      setInvoiceToggle(false);
      window.document.title = "RALCO";
    },
  });

  const toggleArchive = () => {
    let data = JSON.stringify({
      orderId: `${id}`,
      isArchived: true,
    });

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}/mark-as-internal`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        toast({
          title: "Order moved to archive",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        navigate(-1);
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: "Something went wrong please try again",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      });
  };

  // ## GENERATE INVOICE ##
  const generateInvoice = () => {
    setIsInvoiveGen(true);
    let data = JSON.stringify({
      invoiceItems: orderData.OrderItem.map((e, i) => {
        return {
          orderId: e?.orderId,
          orderItemSeqId: e?.orderItemSeqId * 1,
          isValid: true,
          discount: Number(e?.discount).toFixed(2) * 1,
          // "pricePerWeek": tenureData[0]?.tenure.tenurePeriodId === "WEEKLY" ? tenureData[0]?.pricePerWeek * 1 : 0, // unit price * no of days
          pricePerMonth: calObj.totalItemPrice[i], // unit price * no of days
          partyId: `${orderData?.customerPartyId}`,
          taxAmount:
            Number((calObj.totalItemPrice[i] - e?.discount * 1) * 0.18).toFixed(
              2
            ) * 1,
          invoiceDate: `${orderData.placedDate}`,
          dueDateAmount: 0,
        };
      }),
      invoiceMeta: {
        isTaxable: true,
        taxRate: 0.18,
        invoiceTypeId: "ORDER_INVOICE",
        statusId: "ISSUED",
        invoiceDate: `${orderData.placedDate}`,
        orderGstNumber: `${orderData?.orderGstNumber}`,
        description: "any of your choice",
        comment: "any of your choice",
      },
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setIsInvoiveGen(false);
        toast({
          title: "Invoice Generated",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      })
      .catch((error) => {
        console.log(error);
        setIsInvoiveGen(false);
        toast({
          title: "Something went wrong please try again",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      });
  };
  // ## CHECK INVOICE IS GENERATED OR NOT ##
  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice?orderId=${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setGetInvoice(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id, isInvoiceGen]);

  const convertStatus = (str) => {
    // Split the string by underscores
    var words = str.split("_");

    // Capitalize the first letter of each word
    for (var i = 0; i < words.length; i++) {
      words[i] =
        words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
    }

    // Join the words with a space
    var result = words.join(" ");

    return result;
  };

  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openEarlyClosureConfirm, setOpenEarlyClosureConfirm] = useState(false);
  
  const isExtended = (order) => {
    return order.OrderItem[0]?.TenureItem[0]?.tenure?.isExtended
  };
  
  return (
    <Fragment>
      <ConfirmModal
        isOpen={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
        bodyText="Are you sure , you want to mark this order complete ?"
        title="Mark complete"
        onSuccess={() => markOrderComplete()}
      />

      <ConfirmModal
        isOpen={openEarlyClosureConfirm}
        onClose={() => setOpenEarlyClosureConfirm(false)}
        bodyText="Are you sure , you want close this order ?"
        title="Early Closure"
        confirmText="Confirm"
        onSuccess={() => markOrderEarlyClosure()}
      />
      <Box>
        <Flex justifyContent={"space-between"} alignItems={"center"}>
          <Flex
            alignItems={"center"}
            justifyContent={"flex-start"}
            flexBasis={
              title === "Tenure"
                ? "50%"
                : title === "Order ID"
                ? { base: "60%", md: "30%", lg: "30%", xl: "30%", "2xl": "30%" }
                : "30%"
            }
          >
            <BiArrowBack
              onClick={() => navigate(-1)}
              fontSize={"30px"}
              style={{ cursor: "pointer" }}
            />
            {title === "Order" && (
              <Heading
                ml={3}
                fontSize={{
                  base: "15px",
                  md: "24px",
                  lg: "24px",
                  xl: "24px",
                  "2xl": "24px",
                }}
                display={"flex"}
                flexDirection={"row"}
              >
                <Text mt={"10px"}>{title} - </Text>{" "}
                <Box display={"flex"} flexDirection={"column"}>
                  <Text
                    as="span"
                    fontSize={{
                      base: "12px",
                      md: "20px",
                      lg: "20px",
                      xl: "20px",
                      "2xl": "20px",
                    }}
                    fontWeight={"semibold"}
                  >
                    <Tooltip label="Go to Customer Details">
                      <Link
                        to={`/verification/customer-verification-details/${id}`}
                      >
                        <Text
                          as="span"
                          color={"blue.500"}
                          fontWeight={"bold"}
                          ml={"11px"}
                          wordBreak={"break-all"}
                        >
                          {orderName.includes("#")
                            ? orderName
                            : orderName.includes("-")
                            ? orderName.split("-")[4]
                            : orderName}
                        </Text>
                      </Link>
                    </Tooltip>
                  </Text>
                  <Badge
                    ml={"10px"}
                    colorScheme={
                      (orderData?.orderStatusId === "ORDER_CREATED" &&
                        "green") ||
                      (orderData?.orderStatusId === "ORDER_PUBLISHED" &&
                        "facebook") ||
                      (orderData?.orderStatusId === "ORDER_DRAFT" &&
                        "purple") ||
                      (orderData?.orderStatusId === "ORDER_VERIFIED" &&
                        "whatsapp") ||
                      (orderData?.orderStatusId === "ORDER_DELIVERED" &&
                        "yellow") ||
                      (orderData?.orderStatusId === "ORDER_CANCELED" &&
                        "red") ||
                      (orderData?.orderStatusId === "ORDER_OUT_FOR_DELIVERY" &&
                        "orange") ||
                      (orderData?.orderStatusId === "ORDER_TRANSIT" &&
                        "messenger") ||
                      (orderData?.orderStatusId === "ORDER_RETURNED" &&
                        "telegram") ||
                      (orderData?.orderStatusId ===
                        "ORDER_PENDING_FOR_FULFILLMENT" &&
                        "teal") ||
                      (orderData?.orderStatusId ===
                        "ORDER_READY_FOR_FULFILLMENT" &&
                        "linkedin") ||
                      (orderData?.orderStatusId === "ORDER_PICKED" && "pink") ||
                      (orderData?.orderStatusId === "AWAITING_VERIFICATION" &&
                        "cyan") ||
                        (orderData?.orderStatusId === "ACTIVE" &&
                        "whatsapp") || 
                        (orderData?.orderStatusId === "PAYMENT_PENDING" &&
                        "red")
                        || 
                        (orderData?.orderStatusId === "EARLY_CLOSURE" &&
                        "blackAlpha") ||
                        (orderData?.orderStatusId === "ENDED" &&
                        "blackAlpha") ||
                        (orderData?.orderStatusId === "ENDIND_TOMORROW" &&
                        "blackAlpha")
                        
                    }
                  >
                    <Text
                      fontSize={{
                        base: "8px",
                        md: "16px",
                        lg: "16px",
                        xl: "16px",
                        "2xl": "16px",
                      }}
                      fontWeight={"bold"}
                    >
                      {convertStatus(orderData?.orderStatusId)}

                      {isExtended(orderData) ? " (Extended)" : ""}
                      
                      
                    </Text>
                  </Badge>
                  
                </Box>
              </Heading>
            )}
            {title !== "Order" && (
              <Heading
                ml={3}
                fontSize={{
                  base: "15px",
                  md: "24px",
                  lg: "24px",
                  xl: "24px",
                  "2xl": "24px",
                }}
              >
                {title} -{" "}
                <Text
                  as="span"
                  wordBreak={"break-all"}
                  fontSize={{
                    base: "12px",
                    md: "20px",
                    lg: "20px",
                    xl: "20px",
                    "2xl": "20px",
                  }}
                  fontWeight={"semibold"}
                >
                  {orderName.includes("#")
                    ? orderName
                    : orderName.includes("-")
                    ? orderName.split("-")[4]
                    : orderName}
                </Text>
              </Heading>
            )}
          </Flex>

          {orderData?.orderStatusId === "ORDER_VERIFIED" ? (
            <Box
              display={{
                base: "none",
                md: "none",
                lg: "flex",
                xl: "flex",
                "2xl": "flex",
              }}
              flexBasis={title === "Tenure" ? "0%" : "31%"}
              justifyContent={"flex-end"}
            >
              <UpdateDeliveryDateButton
                orderData={orderData}
                tenureData={tenureData}
              />
            </Box>
          ) : null}

          {/* Mark order Internal */}

          {title == "Order" && orderData?.salesChannelEnumId !== "RALCO_INTERNAL_TEST" && (
            <Flex
              flexBasis={title === "Tenure" ? "0%" : "30%"}
              justifyContent={"flex-end"}
            >
              <Button
                onClick={() => {
                  setOpenArchiveConfirm(true);
                }}
                size={{ base: "xs", md: "sm", lg: "sm", xl: "sm", "2xl": "sm" }}
                colorScheme={"telegram"}
                rounded={"lg"}
                ml={3}
              >
                Move to archive
              </Button>
            </Flex>
          )}

          {/* ---- Change Order Status ---- */}
          <Flex
            flexBasis={title === "Tenure" ? "0%" : "39%"}
            justifyContent={"flex-end"}
          >
            <Flex
              alignItems={"center"}
              flexDirection={
                user.UserGroupPermission.includes("ORDER_MANAGEMENT")
                  ? {
                      base: "column",
                      md: "row",
                      lg: "row",
                      xl: "row",
                      "2xl": "row",
                    }
                  : "row"
              }
            >
              {title !== "Tenure" && (
                <Menu>
                  <MenuButton
                    rightIcon={<AiOutlineDown mt={1} />}
                    as={Button}
                    sx={menuButton}
                    size={{
                      base: "xs",
                      md: "sm",
                      lg: "sm",
                      xl: "sm",
                      "2xl": "sm",
                    }}
                    //  width={{base: '132px', md: '203px', lg: '203px', xl: '203px', '2xl': '203px'}}
                    fontSize={{
                      base: "12px",
                      md: "16px",
                      lg: "16px",
                      xl: "16px",
                      "2xl": "16px",
                    }}
                    px={{
                      base: "18px",
                      md: "32px",
                      lg: "32px",
                      xl: "32px",
                      "2xl": "32px",
                    }}
                    //  py={{base: '18px', md: '19px', lg: '19px', xl: '19px', '2xl': '19px'}}
                    isDisabled={menuItems.length === 0 || changeStatusDisable}
                  >
                    {"Change Status"}
                  </MenuButton>
                  <MenuList>
                    {menuItems
                      .filter((item) => item.status != "ORDER_DELIVERED" && item.status != "ORDER_OUT_FOR_DELIVERY")
                      .map((element, i) => {
                        return (
                          <MenuItem
                            key={i}
                            sx={menuStyle}
                            onClick={() => {
                              if (element.title !== "Canceled") {
                                statusHandler(element);
                              } else {
                                onOpen3();
                              }
                            }}
                          >
                            {element.title}
                          </MenuItem>
                        );
                      })}
                  </MenuList>
                </Menu>
              )}

              {/* ---- Assign for Delivery ---- */}
              {/* {title === "Order" &&
                orderData.orderStatusId === "ORDER_VERIFIED" &&
                title !== "Order ID" &&
                prevSelectedPartner.length === 0 && (
                  <>
                    <Menu width={200}>
                      <MenuButton
                        rightIcon={<AiOutlineDown />}
                        as={Button}
                        sx={menuButton}
                        onClick={deliveryBoyList}
                        rounded={"lg"}
                        ml={3}
                        size={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                      >
                        Assign for Delivery
                      </MenuButton>
                      {allUser.length > 0 && title === "Order" ? (
                        <MenuList
                          h={{
                            base: `${window.innerHeight - 150}px`,
                            md: `${window.innerHeight - 150}px`,
                            lg: `${window.innerHeight - 150}px`,
                            xl: `${window.innerHeight - 250}px`,
                            "2xl": "auto",
                          }}
                          overflowY={"scroll"}
                        >
                          {allUser
                            .filter(
                              (x) =>
                                x.UserGroupPermission.find(
                                  (y) =>
                                    y.userPermissionId === "DELIVERY_MANAGEMENT"
                                ) &&
                                x.UserGroupMember.find(
                                  (z) => z.userGroupId !== "ADMIN"
                                )
                            )
                            ?.map((e, i) => {
                              return (
                                <MenuItem
                                  key={i}
                                  sx={menuStyle}
                                  onClick={() => {
                                    assignDelivery(e);
                                  }}
                                >{`${e.firstName} ${e.lastName}`}</MenuItem>
                              );
                            })}
                        </MenuList>
                      ) : (
                        <MenuList
                          h={{
                            base: `${window.innerHeight - 150}px`,
                            md: `${window.innerHeight - 150}px`,
                            lg: `${window.innerHeight - 150}px`,
                            xl: `${window.innerHeight - 150}px`,
                            "2xl": "auto",
                          }}
                          overflowY={"scroll"}
                        >
                          <Flex
                            width={"100%"}
                            justifyContent={"center"}
                            alignItems={"center"}
                            mt={2}
                          >
                            <Spinner size="md" color="blue.500" />
                          </Flex>
                        </MenuList>
                      )}
                    </Menu>
                  </>
                )} */}
              {prevSelectedPartner.length > 0 &&
                (title === "Order" ||
                  (title === "Order ID" &&
                    (user.userGroupMember.includes("ADMIN") ||
                      userPermission.includes("ORDER_MANAGEMENT")))) &&
                (orderData.orderStatusId === "ORDER_VERIFIED" ||
                  orderData.orderStatusId === "ORDER_OUT_FOR_DELIVERY" ||
                  orderData.orderStatusId === "ORDER_DELIVERED" ||
                  orderData.orderStatusId === "ORDER_CANCELED") &&
                (user.userGroupMember.includes("ADMIN") ||
                  (user.userGroupMember.includes("MEMBER") &&
                    userPermission.includes("DELIVERY_MANAGEMENT"))) && (
                  <>
                    <Popover>
                      <PopoverTrigger>
                        <Button
                          shadow={"md"}
                          colorScheme={"telegram"}
                          rounded={"full"}
                          ml={
                            user.UserGroupPermission.includes(
                              "ORDER_MANAGEMENT"
                            )
                              ? { base: 0, md: 3, lg: 3, xl: 3, "2xl": 3 }
                              : 3
                          }
                          mt={
                            user.UserGroupPermission.includes(
                              "ORDER_MANAGEMENT"
                            )
                              ? {
                                  base: "6px",
                                  md: "0px",
                                  lg: "0px",
                                  xl: "0px",
                                  "2xl": "0px",
                                }
                              : 0
                          }
                          size={{
                            base: "xs",
                            md: "sm",
                            lg: "sm",
                            xl: "sm",
                            "2xl": "sm",
                          }}
                        >
                          Assigned Partner
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent>
                        <PopoverArrow />
                        <PopoverCloseButton />
                        <PopoverHeader>
                          <Text fontWeight={"semibold"} color={"gray.600"}>
                            Assingned Partner Details
                          </Text>
                        </PopoverHeader>
                        <PopoverBody>
                          <Text
                            color={"gray.600"}
                            fontSize={"15px"}
                            fontWeight={"semibold"}
                          >
                            Name -{" "}
                            {pickedPartner[0]?.firstName +
                              " " +
                              pickedPartner[0]?.lastName}
                          </Text>
                          <Text
                            color={"gray.600"}
                            fontSize={"15px"}
                            fontWeight={"semibold"}
                          >
                            Email - {pickedPartner[0]?.email}
                          </Text>
                          <Text
                            color={"gray.600"}
                            fontSize={"15px"}
                            fontWeight={"semibold"}
                          >
                            Phone - {pickedPartner[0]?.phone}
                          </Text>
                        </PopoverBody>
                        {orderData.orderStatusId === "ORDER_VERIFIED" &&
                          orderData.orderStatusId !==
                            "ORDER_OUT_FOR_DELIVERY" && (
                            <PopoverFooter width={"100%"}>
                              <Button
                                colorScheme={"red"}
                                onClick={removeAssignedPartner}
                                w={"full"}
                              >
                                Remove
                              </Button>
                            </PopoverFooter>
                          )}
                      </PopoverContent>
                    </Popover>
                  </>
                )}
            </Flex>
          </Flex>

          <Flex
            flexBasis={title === "Tenure" ? "50%" : "31%"}
            justifyContent={"flex-end"}
            display={{
              base: "none",
              md: "none",
              lg: "flex",
              xl: "flex",
              "2xl": "flex",
            }}
          >
            {/* ---- Generate Invoice -- Tenure ------*/}
            {title === "Tenure" && tenureStatus !== "CANCELED" && (
              <Tooltip label="Generate Manual Invoice">
                <Button
                  shadow={"md"}
                  colorScheme={"green"}
                  rounded={"full"}
                  ml={3}
                  size={"sm"}
                  onClick={onOpen1}
                >
                  Generate Manual Invoice
                </Button>
              </Tooltip>
            )}

            {/* ----- Create Invoice -- Order ----- */}
            {title === "Order" &&
              orderData.orderStatusId !== "ORDER_DRAFT" &&
              orderData.orderStatusId !== "ORDER_PUBLISHED" &&
              orderData.orderStatusId !== "ORDER_CANCELED" && (
                <Button
                  shadow={"md"}
                  colorScheme={"telegram"}
                  rounded={"full"}
                  ml={3}
                  size={"sm"}
                  isLoading={isInvoiceGen}
                  // onClick={() => {
                  //   window.document.title = "Ralco_OrderName_InvoiceName"
                  //   handlePrint()
                  //   }}
                  onClick={() => {
                    if (
                      getInvoice.find(
                        (x) => x.invoiceTypeId === "ORDER_INVOICE"
                      )
                    ) {
                      window.document.title =
                        getInvoice.find(
                          (x) => x.invoiceTypeId === "ORDER_INVOICE"
                        ).statusId === "PAID"
                          ? getInvoice.find(
                              (x) => x.invoiceTypeId === "ORDER_INVOICE"
                            ).invoiceIdentifier
                          : `${
                              getInvoice.find(
                                (x) => x.invoiceTypeId === "ORDER_INVOICE"
                              ).invoiceName
                            }`;
                      handlePrint();
                    } else {
                      generateInvoice();
                    }
                  }}
                >
                  {getInvoice.find((x) => x.invoiceTypeId === "ORDER_INVOICE")
                    ? "Print Invoice"
                    : "Generate Order Invoice"}{" "}
                  {/* create invoice and api call when order verified*/}
                </Button>
              )}
          </Flex>
        </Flex>
      </Box>

      {/* Secure Order Invoice Print */}
      {invoiceToggle && (
        <Box style={{ display: "none" }}>
          <Box ref={orderInvoiceRef}>
            <OrderInvoice
              orderData={orderData}
              tenureData={tenureData}
              getInvoice={getInvoice}
              rentalInvoice={
                getInvoice.find((x) => x.invoiceTypeId === "ORDER_INVOICE")
                  .statusId === "PAID"
                  ? getInvoice.find((x) => x.invoiceTypeId === "ORDER_INVOICE")
                      .invoiceIdentifier
                  : `${
                      getInvoice.find(
                        (x) => x.invoiceTypeId === "ORDER_INVOICE"
                      ).invoiceName
                    }`
              }
            />
          </Box>
        </Box>
      )}

      {/* Otp modal */}
      {otpModalToggle && (
        <OtpDeliveryBoy
          onClose2={onClose2}
          isOpen2={isOpen2}
          deliveredRender={deliveredRender}
          mobile={mobile}
        />
      )}

      {/* Generate Invoice Modal -- Tenure */}
      <Modal isOpen={isOpen1} onClose={onClose1}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign={"center"}>Generate Invoice</ModalHeader>
          <Divider />
          <ModalCloseButton />
          <ModalBody pb={6}>
            <GenerateInvoice
              invoiceDetails={invoiceDetails}
              onClose1={onClose1}
              updateTenureDetailsTable={updateTenureDetailsTable}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* ### CANCEL ORDER ALERT BOX ### */}

      <AlertDialog
        isOpen={isOpen3}
        onClose={onClose3}
        motionPreset="slideInBottom"
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Cancel Order
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                colorScheme="red"
                onClick={() => {
                  statusHandler({
                    status: "ORDER_CANCELED",
                    title: "Canceled",
                  });
                  onClose3();
                }}
              >
                Yes
              </Button>
              <Button colorScheme="blue" onClick={onClose3} ml={3}>
                No
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <AlertDialog
        isOpen={openArchiveConfirm}
        onClose={() => {
          setOpenArchiveConfirm(false);
        }}
        motionPreset="slideInBottom"
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Archive order
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                colorScheme="red"
                onClick={() => {
                  toggleArchive();
                  setOpenArchiveConfirm(false);
                }}
              >
                Yes
              </Button>
              <Button
                colorScheme="blue"
                onClick={() => {
                  setOpenArchiveConfirm(false);
                }}
                ml={3}
              >
                No
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Fragment>
  );
};

export default DetailsHeader;
